export {default} from './CustomersTable';
